import React, { useState } from "react";
import { Flex, Link } from "@chakra-ui/react";

const LogoHeader = ({ isSticky, useRealColors }) => {
  const [isHovered, setIsHovered] = useState(false);

  const fillColor1 = useRealColors
    ? "#DD9331"
    : isHovered
      ? "#DD9331"
      : isSticky
        ? "#ffffff90"
        : "#ffffff50";
  const fillColor2 = useRealColors
    ? "#A45826"
    : isHovered
      ? "#A45826"
      : isSticky
        ? "#ffffff90"
        : "#ffffff50";
  const fillColor3 = useRealColors
    ? "#115945"
    : isHovered
      ? "#115945"
      : isSticky
        ? "#ffffff90"
        : "#ffffff50";

  return (
    <>
      <Flex zIndex={4} dropShadow={"2px 2px 5px rgba(0, 0, 0, 0.9)"}>
        <Link
          href="/"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 88 27"
            width="100px"
            height="auto"
            alt="Nathan Martins Logo"
          >
            <path
              d="M14.1.3c7.4,0,13.3,5.9,13.3,13.2v11.4c0,1-.8,1.8-1.8,1.8H2.5c-1,0-1.8-.8-1.8-1.8v-11.4C.7,6.2,6.7.3,14.1.3Z"
              fill={fillColor1}
              strokeWidth="0px"
              style={{ transition: "fill 0.3s ease" }}
            />
            <path
              d="M70.1,25.8L56.5,3.2c-.8-1.3.2-2.9,1.6-2.9h27.2c1.5,0,2.4,1.6,1.6,2.9l-13.6,22.6c-.7,1.2-2.5,1.2-3.3,0Z"
              fill={fillColor2}
              strokeWidth="0px"
              style={{ transition: "fill 0.3s ease" }}
            />
            <path
              d="M49.5,1.2l13.6,22.6c.8,1.3-.2,2.9-1.6,2.9h-27.2c-1.5,0-2.4-1.6-1.6-2.9L46.2,1.2c.7-1.2,2.5-1.2,3.3,0Z"
              fill={fillColor3}
              strokeWidth="0px"
              style={{ transition: "fill 0.3s ease" }}
            />
          </svg>
        </Link>
      </Flex>
    </>
  );
};

export default LogoHeader;
